import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

export const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.enumeration<
    graphql.schema.OccupantPayrollAssignment,
    ents.extra.space.Record.Occupant.Payroll.Assignment
  >({
    [graphql.schema.OccupantPayrollAssignment.None]:
      ents.extra.space.Record.Occupant.Payroll.Assignment.None,
    [graphql.schema.OccupantPayrollAssignment.Partial]:
      ents.extra.space.Record.Occupant.Payroll.Assignment.Partial,
    [graphql.schema.OccupantPayrollAssignment.Full]:
      ents.extra.space.Record.Occupant.Payroll.Assignment.Full,
  }),
)
